/*
	Drives every [data-21e-countdown] on the page.

	One file for all of them: the top bar and the product page both render the same
	snippet, and a per-section copy is how the language picker ended up with markup
	nobody was driving.

	The deadline arrives as unix seconds already resolved in shop time by Liquid, so
	all this does is subtract the visitor's clock. No date parsing in the browser,
	which is what makes the campaign end at the same instant everywhere.

	Re-runs on shopify:section:load because the theme editor swaps in fresh markup
	without re-executing scripts; without that an editor sees a timer stuck on 00
	and hidden by the CSS, and assumes it is broken.
*/
(function () {
	if (window.__21eCountdownLoaded) return;
	window.__21eCountdownLoaded = true;

	var NAMES = ['days', 'hours', 'minutes', 'seconds'];
	var timers = new WeakMap();

	function pad(n) {
		return String(n).padStart(2, '0');
	}

	function start(el) {
		var existing = timers.get(el);
		if (existing) clearInterval(existing);

		var deadline = parseInt(el.getAttribute('data-deadline'), 10) || 0;
		if (!deadline) return;

		var units = {};
		var missing = false;
		NAMES.forEach(function (n) {
			units[n] = el.querySelector('[data-21e-countdown-unit="' + n + '"]');
			if (!units[n]) missing = true;
		});
		if (missing) return;

		var hideSelector = el.getAttribute('data-hide-target');

		function tick() {
			var left = deadline - Math.floor(Date.now() / 1000);

			if (left <= 0) {
				var target = hideSelector ? document.querySelector(hideSelector) : el;
				if (target) target.hidden = true;
				clearInterval(timers.get(el));
				timers.delete(el);
				return;
			}

			units.days.textContent = pad(Math.floor(left / 86400));
			units.hours.textContent = pad(Math.floor((left % 86400) / 3600));
			units.minutes.textContent = pad(Math.floor((left % 3600) / 60));
			units.seconds.textContent = pad(left % 60);
			el.setAttribute('data-ready', 'true');
		}

		tick();
		timers.set(el, setInterval(tick, 1000));
	}

	function initAll(root) {
		(root || document).querySelectorAll('[data-21e-countdown]').forEach(start);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			initAll();
		});
	} else {
		initAll();
	}

	document.addEventListener('shopify:section:load', function (event) {
		initAll(event.target);
	});
})();
